export enum ThirdPartyTermOfNoticePeriodEnum {
    None = 1,
    Day = 2,
    Week = 3,
    Month = 4,
}
